<template>
  <el-container class="login_bg" type="flex" style="height:100%">
    <div class="title-welcome">欢迎使用闪销云！</div>
    <el-main>
      <el-card class="box-card">
        <div class="wrap-box">

          <img :src="require('@/assets/images/home-icon-01.png')" alt="闪销云">
          <div class="card-right">
            <div class="right-title">
              <div>经 销 商 管 理 系 统</div>
              <div class="title-s">标准版</div>
            </div>
            <div class="btns">
              <el-button plain class="yellow_btn" v-if="isPay == 1">进入使用</el-button>
              <div style="display: flex;" v-else>
                <el-button plain class="yellow_btn plain_btn" @click="handleBuy" v-if="access_token == ''">创建自己账号</el-button>
                <a :href="locationHref" target="_blank" v-else>
                  <el-button plain class="yellow_btn" style="margin-right: 20px;">进入使用</el-button>
                </a><br>
                <el-button plain class="yellow_btn" @click="dialogVisible = true">预约演示</el-button>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card class="box-card">
        <div class="wrap-box">
          <img :src="require('@/assets/images/home-icon-02.png')" alt="闪销云">
          <div class="card-right">
            <div class="right-title">
              <div>经 销 商 管 理 系 统</div>
              <div class="title-s title-ss">旗舰版</div>
            </div>
            <div class="btns">
              <el-button plain class="yellow_btn" @click="dialogVisible = true">预约演示</el-button>
            </div>
          </div>
        </div>
      </el-card>
      <el-dialog title="联系我们" :visible.sync="dialogVisible" width="60%" center>
        <div class="content">
          请联系我们{{ customerServiceNumber }}！
        </div>
      </el-dialog>

    </el-main>
    <div class="footer-copyright">Copyright@2016-2023杭州闪派网络科技有限公司版权所有 网站备案/许可证号：
      <a href="https://beian.miit.gov.cn/" target="“_blank&quot;">浙ICP备16031137号</a>
      <img :src="require('@/assets/images/gongan.png')" alt="" style="vertical-align: middle;margin-left: 10px;"> 浙公网安备案
      <a href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010502007569"
        target="“_blank&quot;">33010502007569</a>
    </div>
  </el-container>
</template>
<script>
import {
  getPaymentInfo
} from '@/api.js'
import {
  mapState
} from 'vuex'

export default {
  name: "SystemWelcome",
  data() {
    return {
      isPay: 0,
      locationHref: 0,
      dialogVisible: false
    }
  },
  created() {
    this.getPaymentInfo()
    const location = window.location.href.indexOf('192.168.0.')
    const location200 = window.location.href.indexOf('gogit.52shanpai.com')
    const locationP = window.location.href.indexOf('dealer.52shanpai.com')
    if (location != -1) {
      this.locationHref = 'http://192.168.0.102:5173/'
    } else if (location200 != -1) {
      this.locationHref = 'http://gogit.52shanpai.com:1240/'
    } else if (locationP != -1) {
      this.locationHref = 'https://dealer.52shanpai.com:9191/'
    }
  },
  mounted() { },
  methods: {
    handleBuy() {
      this.$router.push({
        path: '/login'
      })
    },
    getPaymentInfo() {
      getPaymentInfo().then(res => {
        if (res.code == 0) {
          this.$store.commit("refreshCustomerServiceNumber", res.data.info.contactCustomerService)
        } else {
          this.$message.error(res.message)
        }
      })
    },
  },
  computed: {
    ...mapState({
      indexPath: state => state.indexPath,
      access_token: state => state.access_token,
      customerServiceNumber: state => state.customerServiceNumber
    }),
  },
}
</script>

<style scoped lang="scss">
.login_bg {
  background-image: url(../../assets/images/home-bj.png);
  background-size: auto;
}

.title-welcome {
  font-weight: bold;
  text-align: center;
  font-size: 48px;
  margin: 100px 0;
}

.el-container {
  flex-direction: column;

  .footer-copyright {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #B6B6B6;
    padding: 20px 0;
    a{
      color: #B6B6B6;
    }
  }
}

.el-main {
  width: 1600px;
  height: auto;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  // align-items: center;
  justify-content: space-between;
}

.el-card {
  // width: 380px;
  // height: 372px;
  // background: #FFFFFF;
  // box-shadow: 0px 8px 16px 0px rgba(149, 157, 165, 0.15);
  // border-radius: 12px 12px 12px 12px;
  // opacity: 1;
  // margin-right: 32px;

  width: 730px;
  height: 284px;
  background: #FFFFFF;
  box-shadow: 0px 2px 15px 0px rgba(205, 209, 215, 0.3);
  border-radius: 12px;

  .wrap-box {
    display: flex;
    align-content: center;
  }

  img {
    width: 204px;
    height: 204px;
    // vertical-align: bottom;
    margin-right: 30px;
  }

  .card-right{
    margin-top: 25px;
  }

  .right-title {
    display: flex;

    >:nth-child(1) {
      font-weight: bold;
      font-size: 32px;
    }

    .title-s {
      width: 92px;
      height: 32px;
      line-height: 32px;
      text-align: center;
      background: linear-gradient(270deg, #06AEFA 0%, #0158F4 100%);
      border-radius: 21px;
      color: #FFFFFF;
      margin-top: 8px;
      margin-left: 10px;
    }
    .title-ss{
      
background: linear-gradient(270deg, #F395F8 0%, #9C53D1 100%);
    }
  }

  .title {
    display: inline-block;
    font-size: 32px;
    font-family: PingFang SC-Semibold, PingFang SC;
    font-weight: 600;
    color: #1B283C;
  }


  .title_profession {
    color: #0177F9;
  }

  .btns {
    display: flex;
    margin-top: 50px;

    .el-button {
      width: 180px;
height: 54px;
background: linear-gradient(180deg, #16C0F5 0%, #068EFA 100%);
border-radius: 30px;
margin-right: 10px;
    }
    .plain_btn{
      background: none;
      color: #0277F9;
      border-color: #0277F9;
    }
  }

}

.el-card:last-child {
  margin-right: 0;
}

.content {
  text-align: center;
  font-size: 30px;
}</style>